<template>
  <Teleport to="body">
    <div class="login-page">
      <div class="login-card">
        <!-- Logo标题区域 -->
        <div class="login-header">
          <img :src="avatarSrc" class="header‑avatar‑gif" alt="avatar"/>
          <router-link to="/">
            <h1 class="logo-title">LupataID</h1>
          </router-link>
        </div>
        <form @submit.prevent="handleLogin" class="login-form">
          <!-- 账号输入框 -->
          <div class="form-item">
            <input
                v-model="form.account"
                type="text"
                placeholder="请输入用户名/邮箱"
                required
                @input="onUserInput"
            />
          </div>

          <!-- 密码输入框 + 显示隐藏密码 -->
          <div class="form-item password-wrap">
            <input
                v-model="form.password"
                :type="showPwd ? 'text' : 'password'"
                placeholder="请输入密码"
                required
                @input="onUserInput"
            />
            <span class="eye-icon" @click="showPwd = !showPwd">
              <svg class="icon" viewBox="0 0 1024 1024"
                   xmlns="http://www.w3.org/2000/svg" width="25" height="25">
                <path
                    d="M332.8 729.6l34.133333-34.133333c42.666667 12.8 93.866667 21.333333 145.066667 21.333333 162.133333 0 285.866667-68.266667 375.466667-213.333333-46.933333-72.533333-102.4-128-166.4-162.133334l29.866666-29.866666c72.533333 42.666667 132.266667 106.666667 183.466667 192-98.133333 170.666667-243.2 256-426.666667 256-59.733333 4.266667-119.466667-8.533333-174.933333-29.866667z m-115.2-64c-51.2-38.4-93.866667-93.866667-132.266667-157.866667 98.133333-170.666667 243.2-256 426.666667-256 38.4 0 76.8 4.266667 110.933333 12.8l-34.133333 34.133334c-25.6-4.266667-46.933333-4.266667-76.8-4.266667-162.133333 0-285.866667 68.266667-375.466667 213.333333 34.133333 51.2 72.533333 93.866667 115.2 128l-34.133333 29.866667z m230.4-46.933333l29.866667-29.866667c8.533333 4.266667 21.333333 4.266667 29.866666 4.266667 46.933333 0 85.333333-38.4 85.333334-85.333334 0-12.8 0-21.333333-4.266667-29.866666l29.866667-29.866667c12.8 17.066667 17.066667 38.4 17.066666 64 0 72.533333-55.466667 128-128 128-17.066667-4.266667-38.4-12.8-59.733333-21.333333zM384 499.2c4.266667-68.266667 55.466667-119.466667 123.733333-123.733333 0 4.266667-123.733333 123.733333-123.733333 123.733333zM733.866667 213.333333l29.866666 29.866667-512 512-34.133333-29.866667L733.866667 213.333333z"
                    :fill="showPwd?'var(--laputa-primary)':'var(--laputa-common-thirdary-font-color)'">
                </path></svg>
            </span>
          </div>
          <!-- 忘记密码｜立即注册 行 -->
          <div class="link-row">
            <LaputaResetPassword v-model:open="forgetPassword"/>
            <a class="link-text" @click="open">重置密码</a>
            <router-link to="/register" class="link-text">没有账号？立即注册</router-link>
          </div>

          <!-- 登录主按钮 -->
          <button class="login-btn" type="submit" :disabled="loading">
            {{ loading ? "登录中…" : "登录" }}
          </button>
          <button class="login-btn" type="button" @click="handleLogin(1)">
            <svg class="icon" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"
                width="20" height="20">
              <path
                  d="M113.431273 286.184727a23.272727 23.272727 0 0 1 40.494545 22.970182C114.362182 378.88 93.090909 458.984727 93.090909 542.487273a488.727273 488.727273 0 0 0 1.349818 36.235636 23.272727 23.272727 0 0 1-46.429091 3.444364A535.272727 535.272727 0 0 1 46.545455 542.487273c0-91.578182 23.342545-179.595636 66.885818-256.302546zM959.069091 681.029818a23.272727 23.272727 0 0 1-44.916364-12.241454c11.101091-40.657455 16.779636-83.083636 16.779637-126.301091 0-91.066182-25.274182-178.013091-71.842909-251.741091a23.272727 23.272727 0 0 1 39.330909-24.855273C949.690182 347.042909 977.454545 442.600727 977.454545 542.487273c0 47.383273-6.237091 93.882182-18.385454 138.542545zM829.696 180.014545a23.272727 23.272727 0 1 1-32.837818 32.977455C719.825455 136.378182 619.054545 93.090909 512 93.090909c-114.711273 0-222.068364 49.687273-300.520727 136.331636a23.272727 23.272727 0 0 1-34.513455-31.232C264.075636 101.981091 383.860364 46.545455 512 46.545455c119.621818 0 232.122182 48.290909 317.672727 133.46909z m-455.028364 7.33091a23.272727 23.272727 0 0 1 18.152728 42.868363c-112.221091 47.522909-186.693818 157.789091-186.786909 283.927273-8.378182 90.670545-34.909091 156.997818-80.80291 198.050909a23.272727 23.272727 0 0 1-31.022545-34.676364c35.863273-32.093091 58.112-87.668364 65.396364-165.515636a352.465455 352.465455 0 0 1 215.063272-324.654545zM807.098182 888.110545a23.272727 23.272727 0 1 1-41.634909-20.805818c9.099636-18.199273 16.989091-37.189818 23.691636-56.925091 27.531636-81.058909 33.349818-156.346182 29.742546-261.003636l-0.698182-20.363636c-0.232727-7.074909-0.325818-12.381091-0.325818-17.012364a23.272727 23.272727 0 0 1 46.545454 0c0 4.049455 0.093091 8.936727 0.302546 15.546182l0.698181 20.224c3.770182 109.847273-2.420364 189.882182-32.209454 277.573818-7.354182 21.690182-16.058182 42.635636-26.112 62.766545z m37.445818-493.079272a23.272727 23.272727 0 0 1-43.915636 15.453091 305.989818 305.989818 0 0 0-305.640728-203.869091 23.272727 23.272727 0 0 1-2.56-46.498909 352.535273 352.535273 0 0 1 352.116364 234.914909z m-273.850182-125.416728a23.272727 23.272727 0 0 1-7.68 45.917091c-66.513455-11.101091-126.906182 5.376-182.760727 50.059637-35.025455 28.020364-50.176 58.321455-57.879273 104.517818-1.466182 8.843636-2.373818 15.639273-4.421818 32.581818-5.678545 46.312727-10.146909 67.444364-22.853818 92.858182a23.272727 23.272727 0 1 1-41.634909-20.805818c9.541818-19.083636 13.265455-36.584727 18.269091-77.730909 2.164364-17.594182 3.118545-24.808727 4.747636-34.56 9.425455-56.645818 29.719273-97.210182 74.705455-133.189819 66.024727-52.829091 139.729455-72.936727 219.508363-59.648zM215.645091 669.207273a23.272727 23.272727 0 0 1 44.148364 14.731636c-13.428364 40.285091-39.796364 79.825455-78.75491 118.807273a23.272727 23.272727 0 1 1-32.930909-32.907637c34.187636-34.187636 56.576-67.770182 67.537455-100.631272z m444.462545-287.045818a23.272727 23.272727 0 0 1 32.930909-32.907637c41.425455 41.425455 61.672727 102.167273 61.672728 181.038546 0 195.909818-41.495273 343.458909-133.399273 453.748363a23.272727 23.272727 0 1 1-35.770182-29.789091c84.014545-100.840727 122.624-238.033455 122.624-423.959272 0-67.444364-16.337455-116.386909-48.058182-148.130909z m-15.127272 130.094545a23.272727 23.272727 0 0 1-46.545455-0.512c0.698182-60.136727-25.367273-86.178909-86.434909-86.178909-61.067636 0-87.109818 26.065455-86.504727 87.970909-12.660364 189.998545-83.386182 325.026909-212.386909 402.408727a23.272727 23.272727 0 1 1-23.947637-39.889454c114.827636-68.887273 178.199273-189.858909 189.858909-363.799273-0.977455-86.155636 46.126545-133.236364 132.980364-133.236364s133.957818 47.080727 132.980364 133.236364zM488.727273 512a23.272727 23.272727 0 0 1 46.545454 0c0 189.253818-63.581091 341.876364-190.557091 456.145455a23.272727 23.272727 0 0 1-31.138909-34.583273C430.405818 828.392727 488.727273 688.453818 488.727273 512z m109.986909 106.170182a23.272727 23.272727 0 0 1 46.010182 7.074909c-25.181091 163.560727-82.408727 284.392727-172.450909 361.565091a23.272727 23.272727 0 1 1-30.254546-35.328c80.616727-69.12 133.096727-179.898182 156.695273-333.312z"
                  fill="var(--laputa-svg-inverse-color)"></path>
            </svg>
            使用通行密钥登录
          </button>
        </form>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import {ref, reactive, computed} from "vue";
import {useRouter} from 'vue-router'

const router = useRouter()
import {useStore} from 'vuex'
import showToast from "@/utils/toast";
import LaputaResetPassword from "@/components/LaputaResetPassword.vue";

const store = useStore()
// 直接调用函数得到store实例
const loading = ref(false);
const showPwd = ref(false);

// 头像资源路径，改成你自己真实gif路径
const AVATAR = {
  default: new URL('@/assets/login-default.gif', import.meta.url).href,
  typing: new URL('@/assets/login-input.gif', import.meta.url).href,
  error: new URL('@/assets/login-fail.gif', import.meta.url).href,
  success: new URL('@/assets/login-success.gif', import.meta.url).href,
}
const isDefaultAvatar = ref(false);
const isSuccessAvatar = ref(false);
const isErrorAvatar = ref(false);
const isInputAvatar = ref(false);

const avatarSrc = computed(() => {
  if (isSuccessAvatar.value) {
    return AVATAR.success
  }
  if (isErrorAvatar.value) {
    return AVATAR.error
  }
  if (isInputAvatar.value && (form.account || form.password)) {
    return AVATAR.typing
  }
  return AVATAR.default
})

// 用户输入立刻清除错误气泡
const onUserInput = () => {
  isErrorAvatar.value = false
  isSuccessAvatar.value = false
  isDefaultAvatar.value = false
  isInputAvatar.value = true
}

const form = reactive({
  account: "",
  password: ""
});

const handleLogin = async (type) => {
  isErrorAvatar.value = false
  isSuccessAvatar.value = false
  try {
    if (type === 1) {
      await store.dispatch("userInfo/loginPasskey", form)
    } else {
      loading.value = true;
      await store.dispatch("userInfo/login", form)
    }
    isSuccessAvatar.value = true
    setTimeout(() => {
      router.replace("/")
    }, 600)
  } catch (e) {
    showToast(e.message)
    isErrorAvatar.value = true
    setTimeout(() => {
      isInputAvatar.value = false
      isErrorAvatar.value = false
      isDefaultAvatar.value = true
    }, 2000)
  } finally {
    loading.value = false;
  }
}
const forgetPassword = ref(false);

function open() {
  forgetPassword.value = true
}
</script>

<style scoped>
.login-page {
  position: relative;
  min-height: 100vh;
  background-color: var(--laputa-body-background);
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 100%;
  overflow: hidden;
  padding: 20px 16px;
}

.login-page::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: var(--background-image);
  background-size: 50%;
  background-position: center;
  background-repeat: no-repeat;
  opacity: 0.08;
  z-index: 0;
}

.login-card {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 520px;
  box-sizing: border-box;
}

.login-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-bottom: 40px;
}

.header‑avatar‑gif {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
  border: 1px solid transparent;
}

.logo-title {
  font-size: var(--laputa-fontsize-28);
  margin: 0;
  font-weight: 600;
  color: var(--laputa-common-font-color);
  text-decoration: underline;
}

.login-form {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.form-item {
  position: relative;
}

.form-item input {
  width: 100%;
  height: 48px;
  padding: 0 25px;
  border: 1px solid var(--laputa-glass-header-separator);
  border-radius: 999px;
  box-sizing: border-box;
  transition: border 0.2s;
  display: flex;
  font-size: var(--laputa-fontsize-15);
  color: var(--laputa-common-thirdary-font-color);
  background: var(--laputa-glass-background);
}

.form-item input:focus {
  outline: none;
  border-color: var(--laputa-primary);
  background: var(--laputa-body-background);
}

.password-wrap .eye-icon {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  display: flex;
  align-items: center;
}

.link-row {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
}

.link-text {
  color: var(--laputa-common-sub-font-color);
  text-decoration: none;
  cursor: pointer;
}

.link-text:hover {
  text-decoration: underline;
}

.login-btn {
  height: 50px;
  border-radius: 999px;
  border: none;
  background-color: var(--laputa-svg-color);
  color: var(--laputa-common-inverse-font-color);
  font-size: var(--laputa-fontsize-15);
  cursor: pointer;
  transition: opacity 0.2s;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
}

.login-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.privacy-desc p {
  margin: 4px 0;
}

@media (max-width: 1024px) {
  .login-page::before {
    background-size: 100%;
  }

  .login-header {
    margin-bottom: 32px;
  }

  .logo-title {
    font-size: 22px;
  }
}

@media (max-width: 768px) {
  .login-page::before {
    background-size: 100%;
    opacity: 0.07;
  }

  .login-header {
    margin-bottom: 28px;
    gap: 8px;
  }

  .logo-title {
    font-size: 20px;
  }

  .form-item input {
    height: 44px;
  }

  .login-btn {
    height: 46px;
  }

  .link-row {
    flex-direction: column;
    gap: 8px;
    align-items: center;
  }
}
</style>